import { colors, mixin, themeColors } from "@hubrise/react-components"
import styled, { css } from "styled-components"

const padding = css`
  padding: 0.25rem 0;
`

export const Name = styled.div`
  ${padding};
  text-decoration: underline;
  cursor: pointer;
`

export const MinMax = styled.div`
  ${padding};
`

export const Options = styled.div`
  ${padding};
  ${mixin.noWrapEllipsis};
  max-width: 20rem;
`

export const Empty = styled.div`
  color: ${colors.textLight};
`

export const Link = styled.a`
  color: ${themeColors.primary};
`
